<template>
  <div class="modal .collapse.show" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="delete-modal-header">
          <h3 class="modal-title">Agente de registro de um PSBIO externo</h3>
          <button v-on:click="hide" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="delete-body">
          <div class="body-title">adicionar agente de registro externo</div>

          <div class="delete-row">
            <div class="form-group">
              <label class="delete-label">CPF do novo agente</label>
              <input type="text" class="form-control" id="cpf" v-model="cpf" readonly required>
            </div>
          </div>

          <div v-if="loading" class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <samp class="external-response">{{ apiResponse }}</samp>
        </div>

        <div class="modal-footer">
          <button type="button" v-on:click="hide" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button v-if="enrollBtn" type="button" v-on:click="register" class="btn btn-primary">
            Registrar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import interceptor from '../../interceptor'

export default {
  name: 'ExternalAgentModal',
  data: function () {
    return {
      loading: false,
      enrollBtn: true,
      apiResponse: ''
    }
  },
  props: {
    cpf: ''
  },
  methods: {
    register: function (event) {
      event.preventDefault()

      this.loading = true
      const cpf = this.cpf
      const operationIdentifier = window.localStorage.getItem('usercod')
      let apiResponse

      interceptor.request('post', 'api/v1/psbio/add/external/agent', {
        cpf,
        operationIdentifier
      }).then(response => {
        apiResponse = response.data.message
      }).catch(function (error) {
        apiResponse = error
      }).finally(() => {
        this.loading = false
        this.enrollBtn = false

        if (apiResponse.includes('BIO-DATA-PSBIO')) {
          this.apiResponse = 'Agente já cadastrado na Base PSBIO'
        } else if (apiResponse.includes('PSBIO network')) {
          this.apiResponse = 'Agente não está cadastrado na base da Griaule'
        } else if (apiResponse.includes('was registered')) {
          this.apiResponse = 'Agente foi  cadastrado com sucesso'
        } else {
          this.apiResponse = apiResponse
        }
      })
    },
    hide() {
      this.loading = false
      this.apiResponse = ''
      this.enrollBtn = true
    }
  }
}
</script>

<style scoped>
.delete-modal-header {
  background-color: #211858;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.delete-modal-header > h3 {
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--color-e9ecef);
}

.delete-modal-header > button {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(141deg) brightness(103%) contrast(103%);
}

.delete-body {
  display: flex;
  flex-direction: column;
  margin: 2rem;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
}

.body-title {
  font-weight: 520;
  font-size: 2rem;
  letter-spacing: 1px;
}

.delete-row {
  display: block;
  width: 100%;
}

.delete-field {
  width: 98%;
}

.delete-label {
  display: block;
  font-size: 1.2rem;
  margin-top: 1rem;
}

.external-response {
  font-size: 14px;
  width: 100%;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// ExternalAgentModal.vue?00a13216